/** Tipos de execução das integrações */
export interface IntegrationTipoExecucao {
    id: number;
    nome: string;
}

export const tipoExecucaoManual: IntegrationTipoExecucao = {id: 1, nome: 'Manual'};
export const tipoExecucaoAutomatica: IntegrationTipoExecucao = {id: 2, nome: 'Automática'};

export const integracaoTiposExecucao: IntegrationTipoExecucao[] = [
    tipoExecucaoManual,
    tipoExecucaoAutomatica
];
